import LoaderButton from 'components/molecules/loader-button'
import cmsFeaturedSellerSearchFormSchema from 'domains/cms-featured-seller/organisms/search-form/cms-featured-seller-search-form-schema'
import CmsFeaturedSellerSelectSearchField from 'domains/cms-featured-seller/molecules/select-search-field'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  handleSubmitForm: PropTypes.func.isRequired
}

/**
 * Form to add featured seller to the list
 * @param {func} handleSubmitForm Handler for submitting the form
 */
const CmsFeaturedSellerSearchForm = ({
  handleSubmitForm
}) => (
  <Formik
    enableReinitialize={ true }
    initialValues={{
      closet_id: ''
    }}
    validationSchema={ cmsFeaturedSellerSearchFormSchema }
    onSubmit={ (values, formikBag) => handleSubmitForm(values, formikBag) }
  >
    {
      (formikBag) => (
        <Form>
          <CmsFeaturedSellerSelectSearchField
            name='closet_id'
            label='Closet (FS)'
            required={ true }
          />

          <LoaderButton
            color='primary'
            type='submit'
            className='float-right'
            isLoading={ formikBag.isSubmitting }
            text='Add'
          />

        </Form>
      )
    }
  </Formik>
)

CmsFeaturedSellerSearchForm.propTypes = propTypes

export default CmsFeaturedSellerSearchForm